import React from 'react';
import Breadcrumb, { BreadcrumbItem } from './Breadcrumb';

interface PageHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  breadcrumbItems?: BreadcrumbItem[];
}

const PageHeader: React.FC<PageHeaderProps> = ({ 
  title, 
  description, 
  children, 
  breadcrumbItems = [] 
}) => {
  console.log('PageHeader - Renderizando');
  
  return (
    <div className="space-y-2 w-full">
      {breadcrumbItems.length > 0 && (
        <Breadcrumb items={breadcrumbItems} />
      )}
      
      <div className="flex flex-row items-center justify-between gap-2 w-full">
        <div>
          <h1 className="text-xl font-extrabold tracking-tight">{title}</h1>
          {description && (
            <p className="text-muted-foreground text-sm">{description}</p>
          )}
        </div>
        {children && (
          <div className="flex-shrink-0">{children}</div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
